import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgLocationOutline24 = function SvgLocationOutline24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.664c-1.18 0-2.14-.982-2.14-2.187 0-1.206.96-2.186 2.14-2.186 1.179 0 2.139.98 2.139 2.186 0 1.205-.96 2.187-2.14 2.187zm0-5.338c-1.7 0-3.084 1.414-3.084 3.151 0 1.738 1.384 3.151 3.084 3.151 1.7 0 3.083-1.413 3.083-3.15 0-1.738-1.383-3.152-3.083-3.152zm6.746 6.826c-.251.512-4.026 6.147-6.731 10.154-2.722-4.014-6.52-9.66-6.77-10.17-1.458-2.977-.89-6.558 1.415-8.915a7.444 7.444 0 0 1 10.679 0c2.31 2.362 2.876 5.95 1.407 8.931zm-.74-9.613a8.374 8.374 0 0 0-12.013 0C3.4 5.19 2.76 9.22 4.4 12.57c.376.765 6.526 9.828 7.226 10.859l.39.572.387-.572c.695-1.03 6.807-10.073 7.185-10.842 1.653-3.351 1.017-7.39-1.583-10.047z",
    fill: "currentColor"
  })));
};

var LocationOutline24Svg = SvgLocationOutline24;

export { LocationOutline24Svg as default };
//# sourceMappingURL=LocationOutline24.svg.js.map
